/* eslint-disable linebreak-style */
/* eslint-disable react/require-default-props */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable object-curly-newline */
/* eslint-disable comma-dangle */
/* eslint react/prop-types: "off" */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent-props */
import React from 'react';
import { Helmet } from 'react-helmet-async';

const ProductSchema = ({ name, description, imagePath }) => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Product",
    name,
    image: `${window.location.origin}${imagePath}`,
    description,
    brand: {
      "@type": "Brand",
      name: "Nube iO",
    },

    offers: {
      "@type": "Offer",
      availability: "https://schema.org/InStock",
      itemCondition: "https://schema.org/NewCondition",
      url: window.location.href,
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

export default ProductSchema;
